export const EXCMDEVICE_SHOW_RESET = 'EXCMDEVICE_SHOW_RESET'
export const EXCMDEVICE_SHOW_SET_ERROR = 'EXCMDEVICE_SHOW_SET_ERROR'
export const EXCMDEVICE_SHOW_SET_RETRIEVED = 'EXCMDEVICE_SHOW_SET_RETRIEVED'
export const EXCMDEVICE_SHOW_TOGGLE_LOADING = 'EXCMDEVICE_SHOW_TOGGLE_LOADING'
